import React, { StyleSheet } from 'react'
import { WarningTwoTone } from '@ant-design/icons'
import './index.css'

const ErrorInfoTip = (props) => {
  return (
    <section
      className={`tip-message-wrap error ${
        !props.text ? 'visibility-hide' : ''
      }`}
    >
      <WarningTwoTone className="tip-message-icon" twoToneColor="#e01e5a" />
      <span className="tip-message-content">{props.text}</span>
    </section>
  )
}

export default ErrorInfoTip
